export enum EnumTpPessoaComissionamento {
    GerenteGeral,
    Gerente,
    Vendedor,
} 